export const sidebar = [
  {
    path: '/impera',
    name: 'Metoda Divide et Impera',
  },
  {
    path: '/greedy',
    name: 'Metoda Greedy',
  },
  {
    path: '/backtracking',
    name: 'Backtracking',
  },

  {
    path: '/dynamic',
    name: 'Programare dinamica',
  },
  {
    path: '/problems',
    name: 'Probleme',
  },
];
